import { Route, BrowserRouter as Router, Routes, Navigate, useLocation } from "react-router-dom"
import { AnimatePresence } from "framer-motion"
import { Contact, Projects, About } from "./pages"
import { Navbar } from "./components"
import Post from "./pages/Post"
import NewPost from "./features/posts/NewPost"
import { NewHome } from "./pages/NewHome"
import GoToTop from "./components/GoToTop"
import ProjectDetails from "./components/ProjectDetails"
import Posts from "./pages/Posts"
import PageTransition from "./components/PageTransition"
import NotFound from "./pages/NotFound"

import "./index.css"
import Upload from "./pages/Upload"

function AnimatedRoutes() {
  const location = useLocation()
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><NewHome /></PageTransition>} />
        <Route path="/about" element={<PageTransition><About /></PageTransition>} />
        <Route path="/projects" element={<PageTransition><Projects /></PageTransition>} />
        <Route path="/posts" element={<PageTransition><Posts /></PageTransition>} />
        <Route path="/project-details" element={<PageTransition><ProjectDetails /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
        <Route path="/new-post" element={<PageTransition><NewPost /></PageTransition>} />
        <Route path="/post" element={<PageTransition><Post /></PageTransition>} />
        <Route path="/upload" element={<PageTransition><Upload /></PageTransition>} />
        <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  )
}

const App = () => {
  return (
    <main>
      <Router>
        <Routes>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <GoToTop />
                <AnimatedRoutes />
              </>
            }
          />
          <Route path="/dashboard/*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </main>
  )
}

export default App
